import { lazy } from "react";
import { PATHS } from "@/lib/router";

const BenchmarkDashboardPage = lazy(
  () => import("./pages/BenchmarkDashboardPage"),
);

export const benchmarkDashboardRoutes = [
  {
    path: PATHS.BENCHMARK_DASHBOARD,
    element: <BenchmarkDashboardPage />,
    handle: {
      permission: { resource: "esg_dashboard", action: "view" },
      dashboardVariant: "benchmark",
    },
  },
];
